export default "__VITE_ASSET__wjqTvX$1__"